import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import MiniLoader from './components/MiniLoader.vue';
import ErrorAlert from './components/ErrorAlert.vue';
import MainLoader from './components/MainLoader.vue';
import SuccessAlert from './components/SuccessAlert.vue';
import globalErrorHandler from '@/globalErrorHandler.js';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { shortDate } from '@/helpers/tools';
import VueApexCharts from "vue3-apexcharts";

axios.defaults.baseURL = store.getters['BACKEND_URL'];
axios.interceptors.request.use((config) => {
  if (localStorage.getItem('userToken')) {
    config.headers["X-Admin-Token"] = localStorage.getItem('userToken');
  }
  // if (config.url.includes("chat.stream-io-api.com")) {
  //   delete config.headers["X-Admin-Token"];
  // }
  return config;
});
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      router.push("/login").catch(() => {});
    }
    return Promise.reject(error);
  }
);

store.dispatch('checkUser');
const app = createApp(App); 
app.use(store).use(router).use(VueAxios, axios)
.component('successAlert', SuccessAlert)
.component('loader', MiniLoader).component('mainLoader', MainLoader)
.component('errorAlert', ErrorAlert)
.component("apexchart", VueApexCharts);

app.use(VueSweetalert2);

app.config.globalProperties.$globalError = globalErrorHandler ;
app.config.globalProperties.$shortDate = shortDate ;

app.mount('#app');


